<template>
  <div class="bidding">
    <div class="con1">
      <div class="left">
        <div class="a">Bidding</div>
        <div class="b">
          <span class="b1"> Deadline </span>
          <span class="b2"> {{ deadline }} </span>
        </div>
        <div class="c">
          <span class="c1"> {{ timesLeft }} </span>
          <span class="c2"> Times Left </span>
        </div>
      </div>
      <div class="right">
        <el-tooltip
          class="item"
          effect="light"
          content="Bottom Right 提示文字"
          placement="bottom-end"
          :visible-arrow="false"
          popper-class="myToolTip"
        >
          <el-image
            style="width: 30px; height: 30px"
            :src="require('@/assets/image/t18.png')"
          ></el-image>
          <div slot="content">
            <div class="showContent">
              <!-- createSimilarOrder -->
              <div class="a" @click="similarVisible = true">Create similar order</div>
              <el-divider class="fg"></el-divider>
              <div class="b" @click="cancelTheOrder">cancel the order</div>
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="con2">
      <div class="item" :class="{ active: current === 0 }" @click="change(0)">
        All Writers
        <div class="con2-item_tips">{{ dataObj.all_count }}</div>
      </div>
      <div class="item" :class="{ active: current === 1 }" @click="change(1)">
        Short List
        <div class="con2-item_tips">{{ dataObj.collect_count }}</div>
      </div>
      <div class="item" :class="{ active: current === 2 }" @click="change(2)">
        Invitation
        <div class="con2-item_tips">{{ dataObj.invite_count }}</div>
      </div>
    </div>
    <div class="writerContainer">
      <div class="item" v-for="(item, index) in writerList" :key="item.id">
        <Writer @hire="hire" :showData="item" :current="current" @Refresh="onRefresh"></Writer>
      </div>
      <div class="loading" v-loading="loading" element-loading-text="Looking for Writers..."></div>
    </div>
    <div class="con2-2">
      <div class="bottom">
        <div class="describe">
          <div class="item">
            Pages:<span>{{ orderDetail.pages }}</span>
          </div>
          <div class="item">
            Assignment Type:<span>{{ orderDetail.assignment_type_text }}</span>
          </div>
          <div class="item">
            Assignment Language:<span>{{ orderDetail.assignment_language_text }}</span>
          </div>
          <div class="item">
            Assignment Detail:<span>{{ orderDetail.assignment_details_text }}</span>
          </div>
          <div class="item">
            Education:<span>{{ orderDetail.education_level_text }}</span>
          </div>
          <div class="item">
            Deadline:<span>{{ deadline }}</span>
          </div>
          <div class="item">
            Assignment Topic:<span>{{ orderDetail.assignment_topic }}</span>
          </div>
          <div class="item">
            Number Of Sources:<span>{{ orderDetail.number_of_sources }} sources required</span>
          </div>
          <div class="item">
            Citation Styles:<span>{{ orderDetail.citation_styles_text }}</span>
          </div>
          <div class="item">
            Subject:<span>{{ orderDetail.subject_text }}</span>
          </div>
          <div class="item">
            Instruction：
            <div class="concrete" v-dompurify-html="orderDetail.instructions"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="con3-2">
      <div class="top">Upload Files</div>
      <div class="bottom">
        <FileList
          :showData="orderDetail.files ? orderDetail.files : []"
          :canDeleteFileItem="true"
          @deleteFileItem="deleteFileItem"
        ></FileList>
        <uploadTem :formAdditionalData="formAdditionalData" @onSuccess="onSuccess"></uploadTem>
      </div>
    </div>
   

    <!-- 取消订单 -->
    <el-dialog class="dia" title="Commend" :visible.sync="dialogFormVisible" width="40%">
      <div slot="title">
        <div class="dia-box">
          <div>
            <i class="el-icon-back" @click="dialogFormVisible = false"></i>
            <span class="title">Cancel Order</span>
          </div>

          <div>
            <i class="el-icon-circle-close" @click="dialogFormVisible = false"></i>
          </div>
        </div>
      </div>
      <div>
        <el-select class="se" v-model="reason" placeholder="Select reason" value-key="value">
          <el-option v-for="item in options" :key="item.index" :label="item.label" :value="item">
          </el-option>
        </el-select>
        <el-input
          class="ta"
          type="textarea"
          :rows="4"
          placeholder="Please enter content"
          v-model="textarea"
          resize="none"
        >
        </el-input>
      </div>
      <div slot="footer">
        <div class="btnArea">
          <el-button class="btn1" @click="dialogFormVisible = false">Cancel</el-button>
          <el-button class="btn2" @click="cancelOrder">Cancel order</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 创建相同的订单 -->
    <el-dialog class="dia" title="Commend" :visible.sync="similarVisible" width="40%">
      <div slot="title">
        <div class="dia-box">
          <div>
            <i class="el-icon-back" @click="similarVisible = false"></i>
            <span class="title">Create Similar Order</span>
          </div>

          <div>
            <i class="el-icon-circle-close" @click="similarVisible = false"></i>
          </div>
        </div>
      </div>

      <div class="dia-main_content">Do you want create similar order?</div>

      <div slot="footer">
        <div class="btnArea">
          <el-button class="btn1" @click="similarVisible = false">Cancel</el-button>
          <el-button class="btn2" @click="createSimilarOrder">create</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Writer from '@/components/writer/writer.vue';
import {
  similarOrder,
  getWriterOrderList,
  getDictList,
  cancelOrder,
  getOrderDetail,
  apiUserInviteOrderList,
  hireWriter,
  editFiles,
  apiListCount,
} from '@/api/api.js';
import { mapMutations } from 'vuex';
import FileList from '../../components/file-list/file-list.vue';
import uploadTem from '@/components/uploadTem/index.vue';

export default {
  name: 'bidding',
  data: function () {
    return {
      formAdditionalData: {
        type: 'order',
      },
      dataObj: {},
      similarVisible: false,
      orderDetail: '',
      reason: '',
      textarea: '',
      options: [
        {
          index: 0,
          value: 111,
          label: 'No bids',
        },
        {
          index: 1,
          value: 222,
          label: 'Bids too expensive',
        },
        {
          index: 2,
          value: 333,
          label: 'Do not need',
        },
        {
          index: 3,
          value: 444,
          label: 'Duplicate',
        },
        {
          index: 4,
          value: 555,
          label: 'Other',
        },
        {
          index: 5,
          value: 666,
          label: 'order',
        },
      ],
      dialogFormVisible: false,
      current: 0,
      fileList: [],
      writerList: [
        // {
        //   id: 111,
        //   name: 'Hamlet',
        //   src: require('@/assets/image/t19.png'),
        //   rate: '4.0',
        //   orders: '1234',
        //   reViews: '1234',
        //   success: '100%',
        //   price: '234.00',
        // },
      ],
      NowTime: new Date(),
      setIntervalId: '',
      getWriterOrderListInterValId: '',
      loading: true,
    };
  },
  computed: {
    deadline() {
      // let timestamp = this.$store.state.placeOrderDataObject.orderDetail.deadline;
      // var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var Y = date.getFullYear() + '-';
      // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      // var D = date.getDate() + ' ';
      // var h = date.getHours() + ':';
      // var m = date.getMinutes() + ':';
      // var s = date.getSeconds();
      // return Y + M + D + h + m + s;
      return new Date(this.orderDetail.deadline * 1000).Format('yyyy-MM-dd hh:mm');
    },
    timesLeft() {
      // 指定日期和时间
      var EndTime = new Date(this.orderDetail.deadline * 1000);
      // 当前系统时间
      var NowTime = this.NowTime;
      var t = EndTime.getTime() - NowTime.getTime();
      t >= 0 ? (t = t) : (t = 0);
      var d = Math.floor(t / 1000 / 60 / 60 / 24);
      var h = Math.floor((t / 1000 / 60 / 60) % 24);
      var m = Math.floor((t / 1000 / 60) % 60);
      var s = Math.floor((t / 1000) % 60);
      return d + 'days,' + h + ' hours and ' + m + ' minutes';
    },
  },
  async created() {
    this.$emit('change', 2);
    this.setSetInterval();
    await this.getOrderDetail(this.$route.query.orderId);
    this.getWriterOrderList();
    document.addEventListener('visibilitychange', this.handleBiddingVisibilityChange, false);
    this.getDictList();
    this.getListCount();
  },
  methods: {
    ...mapMutations(['setEmptyPlaceOrderDataObject', 'setOrderDetail', 'setEmptyOrderDetail']),
    async deleteFileItem(index){
      this.orderDetail.files.splice(index, 1);
      await this.editFiles();
      this.getOrderDetail(this.$route.query.orderId);
    },
    // 上传相关 ------------------------------------
    onSuccess(response, file, fileList) {
      console.log('response', response);
      console.log('file', file);
      console.log('fileList', fileList);
      if (response.code === 1) {
        let postData = response.data;
        postData.upload_time = Date.parse(new Date());
        postData.url = response.data.key;
        // 去除文件名前的文件夹
        let str = response.data.key.split('/');
        postData.name = str[str.length - 1];
        postData.id = response.data.hash;

        this.orderDetail.files.push(response.data);
        this.editFiles();
      } else if (response.code === -1) {
        router.push({ name: 'login' });
      } else if (response.code === 0) {
        this.$message({
          type: 'warning',
          message: response.msg,
        });
      }
    },
    async editFiles() {
      let sendData = {
        id: this.orderDetail.id,
        files: this.orderDetail.files,
      };
      let result = await editFiles(sendData);
    },
    // 上传相关 end ------------------------------------
    async getOrderDetail(orderId) {
      let sendData = {
        id: orderId,
      };
      let result = await getOrderDetail(sendData);
      console.log('getOrderDetail result', result);
      this.orderDetail = result;
      this.setOrderDetail(result);
      if (this.orderDetail.status === 1 || this.orderDetail.status === 2) {
        this.$router.push({ name: 'processing', query: { orderId: this.orderDetail.id } });
      } else if (this.orderDetail.status === 10) {
        this.$router.push({ name: 'completeOrder', query: { orderId: this.orderDetail.id } });
      }
    },
    getWriterOrderList() {
      if (this.current == 0 || this.current == 1) {
        this.executeGetWriterOrderList();
      } else {
        this.getInvitation();
      }
      this.getWriterOrderListInterValId = setInterval(() => {
        if (this.current == 0 || this.current == 1) {
          this.executeGetWriterOrderList();
        } else {
          this.getInvitation();
        }
      }, 5000);
    },
    async getListCount() {
      let result = await apiListCount({ order_id: this.orderDetail.id });
      this.dataObj = result;
    },
    // 获取邀请的订单
    async getInvitation() {
      let result = await apiUserInviteOrderList({
        order_id: this.orderDetail.id,
      });
      this.writerList = result.lists.map((item, index, arr) => {
        item.score = parseFloat(item.score);
        return item;
      });
    },
    onRefresh() {
      this.writerList = [];
      this.getWriterOrderList();
      this.getListCount();
    },
    async executeGetWriterOrderList() {
      let sendData = {
        order_id: this.orderDetail.id,
        is_collect: this.current === 0 ? '' : 1,
      };
      let result = await getWriterOrderList(sendData);
      console.log('getWriterOrderList result', result);
      this.writerList = result.lists.map((item, index, arr) => {
        item.score = parseFloat(item.score);
        return item;
      });
    },
    async getDictList() {
      let sendData = {
        type_value: 'Cancel Order',
      };
      let result = await getDictList(sendData);
      console.log('getDictList result', result);
      this.options = result.map((item, index, arr) => {
        item.value = item.id;
        item.label = item.name;
        return item;
      });
    },
    setSetInterval() {
      this.setIntervalId = setInterval(() => {
        this.NowTime = new Date();
      }, 1000);
    },
    change(index) {
      this.current = index;
      this.writerList = [];
      clearInterval(this.getWriterOrderListInterValId);
      this.getWriterOrderList();
      this.getListCount();
    },
    handleBiddingVisibilityChange() {
      if (document.hidden) {
        console.log('bidding hidden');
        clearInterval(this.getWriterOrderListInterValId);
        console.log('getWriterOrderListInterValId Cleared');
      } else {
        console.log('bidding visibility');
        this.getWriterOrderList();
        console.log('getWriterOrderList proceed');
      }
    },
    async createSimilarOrder() {
      let sendData = {
        id: this.orderDetail.id,
      };
      let result = await similarOrder(sendData);
      this.similarVisible = false;
      this.$alert(
        'The copy is successful, a new order has been added to your order list',
        'Kind tips',
        {
          confirmButtonText: 'Sure',
          callback: (action) => {},
        },
      );
      console.log('createSimilarOrder result', result);
    },
    cancelTheOrder() {
      // 根据当前的订单的订单号去请求后端取消当前的订单
      this.dialogFormVisible = true;
    },
    async cancelOrder() {
      let sendData = {
        id: this.orderDetail.id,
        cancel_type: this.reason.value,
        cancel_note: this.textarea,
        cancel_type_text: this.reason.label,
      };
      let result = await cancelOrder(sendData);
      console.log('cancelOrder result', result);

      this.dialogFormVisible = false;
      this.$message({
        type: 'success',
        message: 'Cancel success!',
      });
      this.setEmptyPlaceOrderDataObject();
      this.$router.push({ name: 'orderRequirments' });
    },
    async hire(id) {
      let sendData = {
        id,
        order_id: this.orderDetail.id,
      };
      let result = await hireWriter(sendData);
      console.log('hire result', result);
      this.$message({
        type: 'success',
        message: 'Successful employment!',
      });
      this.$router.push({ name: 'processing', query: { orderId: this.orderDetail.id } });
    },
  },
  // watch: {
  //   '$store.state.placeOrderDataObject.orderId': function (newVal, oldVal) {
  //     console.log('newVal', newVal);
  //     console.log('oldVal', oldVal);
  //   },
  // },
  beforeDestroy() {
    clearInterval(this.setIntervalId);
    console.log('setInterval Cleared');
    clearInterval(this.getWriterOrderListInterValId);
    console.log('getWriterOrderListInterValId Cleared');
    document.removeEventListener('visibilitychange', this.handleBiddingVisibilityChange);
    console.log('removeEventListener：visibilitychange->handleBiddingVisibilityChange');
    this.setEmptyOrderDetail();
  },
  components: { Writer, FileList, uploadTem },
};
</script>
<style lang="scss" scoped>
.bidding {
  .con1 {
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      .a {
        background: rgba(87, 124, 242, 0.1);
        border-radius: 14px;
        padding: 5px 15px;
        font-size: 12px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #577cf2;
      }
      .b {
        margin-left: 50px;
        display: flex;
        align-items: center;
        .b1 {
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
        }
        .b2 {
          margin-left: 7px;
          font-size: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #577cf2;
          border: 1px solid #577cf2;
          padding: 5px;
          border-radius: 4px;
        }
      }
      .c {
        margin-left: 50px;
        display: flex;
        align-items: center;
        .c1 {
          font-size: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #577cf2;
          border: 1px solid #577cf2;
          padding: 5px;
          border-radius: 4px;
        }
        .c2 {
          margin-left: 7px;
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #000000;
        }
      }
    }
    .right {
      .showContent {
        color: white;
      }
    }
  }

  .con2-2 {
    margin-top: 8%;

    .bottom {
      padding: 30px;
      background-color: #fff;
      border-radius: 10px;
      .describe {
        .item {
          margin-top: 20px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9c9c9c;
          span {
            margin-left: 15px;
            color: #000000;
          }
          .concrete {
            margin-top: 20px;
            color: #000000;
            line-height: 22px;
          }
        }
        .item:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .con3-2 {
    margin-top: 20px;
    .top {
      background-color: #e8ebf1;
      border-radius: 10px;
      padding: 20px;
      font-size: 30px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #112a75;
    }
    .bottom {
      position: relative;
      top: -10px;
      padding: 30px;
      background-color: #fff;
      border-radius: 10px;
    }
  }

  .con2 {
    margin-top: 50px;
    display: flex;
    align-items: center;
    .item {
      width: 160px;
      height: 30px;
      background: #ffffff;
      border-radius: 4px;
      font-size: 18px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #000000;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      position: relative;
      .con2-item_tips {
        position: absolute;
        top: -5px;
        font-size: 14px;
        font-weight: 400;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background: #ff0000;
        color: #ffffff;
        border-radius: 50%;
        right: 0px;
      }
    }
    .item:not(:first-child) {
      margin-left: 20px;
    }
    .item.active {
      background: #577cf2;
      border-radius: 4px;
      color: white;
    }
  }
  .writerContainer {
    // ::v-deep .el-loading-mask {
    //   background-color: transparent;
    // }
    .item {
      margin-top: 20px;
    }
    .loading {
      margin-top: 50px;
    }
  }

  .dia {
    ::v-deep .el-dialog {
      background-color: #e6e8ec;
      border-radius: 10px;
      .dia-main_content {
        font-size: 20px;
        padding: 20px 0px;
        border-bottom: #eee solid 1px;
      }
      .el-dialog__header {
        padding: 15px;
        padding-bottom: 0;
        background-color: #e6e8ec;
        border-radius: 10px 10px 0 0;
        .el-dialog__headerbtn {
          display: none;
        }
        .el-icon-back {
          font-size: 24px;
          color: #577cf2;
        }
        .el-icon-circle-close {
          font-size: 24px;
          color: #577cf2;
          cursor: pointer;
        }
        .dia-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .title {
          margin-left: 20px;
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #577cf2;
          line-height: 40px;
        }
      }
      .el-dialog__body {
        background-color: #fff;
        padding: 30px 50px;
        border-radius: 10px 10px 0 0;
        padding-bottom: 0;
        // position: relative;
        // top: -20px;
        .se {
          width: 100%;
          input {
            background-color: #577bf225;
            color: #577cf2;
          }
        }
        .ta {
          margin-top: 40px;
          textarea {
            height: 170px;
            background-color: #fff;
          }
          textarea::-webkit-scrollbar {
            width: 10px;
            // height: 16px;
            background-color: rgba(87, 124, 242, 0.1);
          }
          textarea::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: rgba(87, 124, 242, 0.3);
          }
        }
      }
      .el-dialog__footer {
        background-color: #fff;
        text-align: right;
        border-radius: 0 0 10px 10px;
        padding: 30px 50px;
        // position: relative;
        // top: -20px;
        .btnArea {
          margin-top: 20px;
          .btn1 {
            // background-color: #efeff1;
            // font-size: 20px;
            // border: 2px solid #efeff1;
            font-size: 18px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #577cf2;
            border: 1px solid #577cf2;
            padding: 10px 30px;
            border-radius: 20px;
          }
          .btn2 {
            // background-color: #1eb05c;
            // color: #fff;
            // font-size: 20px;
            // border: 2px solid #1eb05c;
            // box-shadow: 0px 0px 8px 0px #1eb05c;

            font-size: 18px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #fff;
            background: #577cf2;
            border: 1px solid #577cf2;
            padding: 10px 30px;
            border-radius: 20px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.showContent {
  padding: 10px;
  ::v-deep .a,
  .b {
    font-size: 12px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #000000;
    line-height: 24px;
    cursor: pointer;
  }
  ::v-deep .fg {
    margin: 10px 0;
  }
}

.upload-demo {
  margin-top: 20px;
  text-align: center;
  ::v-deep .el-upload.el-upload--text {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
  .upload {
    width: 142px;
    height: 42px;
    background: #577cf2;
    border-radius: 10px;
    font-size: 18px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-light.myToolTip {
  border: none;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);
  padding: 0;
}
</style>
